import AdminUsuarios from "@/components/home/AdminUsuarios.vue";
import AreaPrivada from "@/views/AreaPrivada.vue";
import NotFound from "@/views/NotFound.vue";
import SaludCompleta from "@/views/SaludCompleta.vue";
import Soporte from "@/views/Soporte.vue";
import Vencimientos from "@/views/Vencimientos.vue";
import { createRouter, createWebHistory } from "vue-router";
import { i18n } from '@/main'  // ← Importar i18n
import FichaProducto from "@/components/FichaProducto.vue";
import AvisoLegalCheck from "@/components/AvisoLegalCheck.vue";
import PoliticaCookies from "@/views/PoliticaCookies.vue";

const routes = [
    // Redirigir raíz a /es
    { path: '/', redirect: '/es' },

    // ============================================
    // HOME
    // ============================================
    {
        path: '/:lang',
        props: true,
        component: () => import('@/views/Home.vue'),
        name: 'home',
        meta: {
            title: {
                es: 'ASISA Health Visa | Seguro de Salud para Expatriados en España',
                en: 'ASISA Health Visa | Health Insurance for Expats in Spain',
                zh: 'ASISA Health Visa | 西班牙外籍人士健康保险',
                de: 'ASISA Health Visa | Krankenversicherung für Expats in Spanien',
                fr: 'ASISA Health Visa | Assurance santé pour expatriés en Espagne',
                ar: 'ASISA Health Visa | تأمين صحي للمغتربين في إسبانيا'
            },
            description: {
                es: 'Seguro médico para expatriados en España. Cumple todos los requisitos de Extranjería. Sin copagos, cobertura completa desde el primer día.',
                en: 'Health insurance for expats in Spain. Meets all Immigration requirements. No copayments, full coverage from day one.',
                zh: '西班牙外籍人士医疗保险。满足所有移民局要求。无共付额，从第一天起全面保障。',
                de: 'Krankenversicherung für Expats in Spanien. Erfüllt alle Anforderungen der Ausländerbehörde. Keine Zuzahlungen, vollständiger Schutz ab dem ersten Tag.',
                fr: 'Assurance santé pour expatriés en Espagne. Répond à toutes les exigences de l\'Immigration. Sans copaiement, couverture complète dès le premier jour.',
                ar: 'تأمين صحي للمغتربين في إسبانيا. يلبي جميع متطلبات الهجرة. بدون دفعات مشتركة، تغطية كاملة من اليوم الأول.'
            },
            keywords: {
                es: 'seguro salud expatriados, visa España, NIE, seguro médico sin copagos',
                en: 'expat health insurance, Spain visa, NIE, no copay health insurance',
                zh: '外籍人士健康保险，西班牙签证，NIE，无共付额健康保险',
                de: 'Expat Krankenversicherung, Spanien Visum, NIE, Krankenversicherung ohne Zuzahlung',
                fr: 'assurance santé expatriés, visa Espagne, NIE, assurance santé sans copaiement',
                ar: 'تأمين صحي للمغتربين، تأشيرة إسبانيا، NIE، تأمين صحي بدون دفعات مشتركة'
            }
        }
    },

    // ============================================
    // SEGUROS DE SALUD
    // ============================================
    {
        path: "/:lang/seguros-salud",
        component: SaludCompleta,
        name: "salud-completa",
        props: true,
        meta: {
            title: {
                es: "Seguro de Salud para Expatriados en España | ASISA Health Visa",
                en: "Health Insurance for Expatriates in Spain | ASISA Health Visa",
                zh: "西班牙外籍人士健康保险 | ASISA Health Visa",
                de: "Krankenversicherung für Expatriates in Spanien | ASISA Health Visa",
                fr: "Assurance santé pour expatriés en Espagne | ASISA Health Visa",
                ar: "تأمين صحي للمغتربين في إسبانيا | ASISA Health Visa"
            },
            description: {
                es: "Seguro médico sin copagos que cumple todos los requisitos de Extranjería. Certificado oficial inmediato, cobertura completa desde el primer día. Contrata online.",
                en: "Health insurance with no co-payments that meets all immigration requirements. Immediate official certificate, full coverage from day one. Sign up online.",
                zh: "无共付额的健康保险，满足所有移民局要求。立即获得官方证书，从第一天起全面保障。在线签约。",
                de: "Krankenversicherung ohne Zuzahlungen, die alle Anforderungen der Ausländerbehörde erfüllt. Sofortiges offizielles Zertifikat, vollständiger Schutz ab dem ersten Tag. Jetzt online abschließen.",
                fr: "Assurance santé sans copaiement répondant à toutes les exigences de l'Immigration. Certificat officiel immédiat, couverture complète dès le premier jour. Souscrivez en ligne.",
                ar: "تأمين صحي بدون دفعات مشتركة يلبي جميع متطلبات الهجرة. شهادة رسمية فورية، تغطية كاملة من اليوم الأول. اشترك عبر الإنترنت."
            },
            keywords: {
                es: "seguro salud, seguro médico sin copagos, ASISA Health Visa",
                en: "health insurance, no copay health insurance, ASISA Health Visa",
                zh: "健康保险，无共付额健康保险，ASISA Health Visa",
                de: "Krankenversicherung, Krankenversicherung ohne Zuzahlung, ASISA Health Visa",
                fr: "assurance santé, assurance santé sans copaiement, ASISA Health Visa",
                ar: "تأمين صحي، تأمين صحي بدون دفعات مشتركة، ASISA Health Visa"
            }
        }
    },

    // ============================================
    // SEGUROS DENTALES
    // ============================================
    {
        path: "/:lang/seguros-dentales",
        component: () => import("@/views/SegurosDentales.vue"),
        props: true,
        name: "seguros-dentales",
        meta: {
            title: {
                es: "Seguros Dentales | ASISA Health Visa",
                en: "Dental Insurance | ASISA Health Visa",
                zh: "牙科保险 | ASISA Health Visa",
                de: "Zahnversicherung | ASISA Health Visa",
                fr: "Assurance dentaire | ASISA Health Visa",
                ar: "تأمين الأسنان | ASISA Health Visa"
            },
            description: {
                es: "Seguro dental completo sin copagos. Accede a más de 1.800 clínicas dentales. Sin carencias, desde el primer día.",
                en: "Complete dental insurance with no copayments. Access to more than 1,800 dental clinics. No waiting periods, from day one.",
                zh: "完整的牙科保险，无共付额。可访问超过1,800家牙科诊所。无等待期，从第一天起。",
                de: "Komplette Zahnversicherung ohne Zuzahlungen. Zugang zu mehr als 1.800 Zahnkliniken. Keine Wartezeiten, ab dem ersten Tag.",
                fr: "Assurance dentaire complète sans copaiement. Accès à plus de 1.800 cliniques dentaires. Sans délai de carence, dès le premier jour.",
                ar: "تأمين أسنان كامل بدون دفعات مشتركة. الوصول إلى أكثر من 1,800 عيادة أسنان. بدون فترات انتظار، من اليوم الأول."
            },
            keywords: {
                es: "seguro dental, seguro de dientes, ASISA Health Visa",
                en: "dental insurance, teeth insurance, ASISA Health Visa",
                zh: "牙科保险，牙齿保险，ASISA Health Visa",
                de: "Zahnversicherung, Zahnversicherung, ASISA Health Visa",
                fr: "assurance dentaire, assurance des dents, ASISA Health Visa",
                ar: "تأمين الأسنان، تأمين الأسنان، ASISA Health Visa"
            }
        }
    },

    // ============================================
    // CONTRATACIÓN
    // ============================================
    {
        path: '/:lang/contratacion',
        component: () => import('@/views/Contratacion.vue'),
        name: 'contratacion',
        props: true,
        meta: {
            title: {
                es: 'Contrata tu Seguro de Salud para Visa | ASISA Health Visa',
                en: 'Get your Health Insurance for Visa | ASISA Health Visa',
                zh: '为您的签证购买健康保险 | ASISA Health Visa',
                de: 'Ihre Krankenversicherung für das Visum | ASISA Health Visa',
                fr: 'Souscrivez votre assurance santé pour Visa | ASISA Health Visa',
                ar: 'اشترك في التأمين الصحي للتأشيرة | ASISA Health Visa'
            },
            description: {
                es: 'Calcula tu precio en 1 minuto y obtén el certificado oficial para tu visado. Sin copagos, sin carencias.',
                en: 'Calculate your price in 1 minute and get the official certificate for your visa. No copayments, no waiting periods.',
                zh: '在1分钟内计算您的价格，并获得签证官方证书。无共付额，无等待期。',
                de: 'Berechnen Sie Ihren Preis in 1 Minute und erhalten Sie das offizielle Zertifikat für Ihr Visum. Keine Zuzahlungen, keine Wartezeiten.',
                fr: 'Calculez votre prix en 1 minute et obtenez le certificat officiel pour votre visa. Sans copaiement, sans délai de carence.',
                ar: 'احسب سعرك في دقيقة واحدة واحصل على الشهادة الرسمية لتأشيرتك. بدون دفعات مشتركة، بدون فترات انتظار.'
            },
            keywords: {
                es: 'contratar seguro salud, visa España, seguro médico online',
                en: 'contract health insurance, Spain visa, online health insurance',
                zh: '购买健康保险，西班牙签证，在线健康保险',
                de: 'Krankenversicherung abschließen, Spanien Visum, Online-Krankenversicherung',
                fr: 'souscrire assurance santé, visa Espagne, assurance santé en ligne',
                ar: 'شراء تأمين صحي، تأشيرة إسبانيا، تأمين صحي عبر الإنترنت'
            }
        }
    },

    // ============================================
    // LOGIN
    // ============================================
    {
        path: '/:lang/login',
        component: () => import('@/views/Login.vue'),
        name: 'login',
        props: true,
        meta: {
            title: {
                es: 'Área Privada | Acceso Clientes | ASISA',
                en: 'Private Area | Client Access | ASISA',
                zh: '私人区域 | 客户访问 | ASISA',
                de: 'Privatbereich | Kundenbereich | ASISA',
                fr: 'Espace Privé | Accès Client | ASISA',
                ar: 'المنطقة الخاصة | وصول العميل | ASISA'
            },
            description: {
                es: 'Accede a tu área privada para gestionar tus pólizas y documentación.',
                en: 'Access your private area to manage your policies and documentation.',
                zh: '访问您的私人区域以管理您的保单和文件。',
                de: 'Rufen Sie Ihren Privatbereich auf, um Ihre Policen und Dokumente zu verwalten.',
                fr: 'Accédez à votre espace privé pour gérer vos polices et documents.',
                ar: 'الوصول إلى منطقتك الخاصة لإدارة وثائقك وبوالصك.'
            }
        }
    },

    // ============================================
    // RECOVER PASSWORD
    // ============================================
    {
        path: '/:lang/recover',
        component: () => import('@/views/RecoverPass.vue'),
        name: 'recover',
        props: true,
        meta: {
            title: {
                es: 'Recuperar Contraseña | ASISA',
                en: 'Recover Password | ASISA',
                zh: '找回密码 | ASISA',
                de: 'Passwort wiederherstellen | ASISA',
                fr: 'Récupérer le mot de passe | ASISA',
                ar: 'استعادة كلمة المرور | ASISA'
            },
            description: {
                es: 'Recupera tu contraseña de acceso al área privada de ASISA.',
                en: 'Recover your password to access the ASISA private area.',
                zh: '找回您的密码以访问ASISA私人区域。',
                de: 'Stellen Sie Ihr Passwort für den Zugang zum ASISA-Privatbereich wieder her.',
                fr: 'Récupérez votre mot de passe pour accéder à l\'espace privé ASISA.',
                ar: 'استعادة كلمة المرور الخاصة بك للوصول إلى المنطقة الخاصة بـ ASISA.'
            }
        }
    },

    // ============================================
    // ADMIN
    // ============================================
    {
        path: '/:lang/area-admin',
        component: AdminUsuarios,
        props: true,
        name: 'area-admin',
        meta: {
            title: {
                es: 'Gestión de Usuarios | ASISA',
                en: 'User Management | ASISA',
                zh: '用户管理 | ASISA',
                de: 'Benutzerverwaltung | ASISA',
                fr: 'Gestion des utilisateurs | ASISA',
                ar: 'إدارة المستخدمين | ASISA'
            },
            description: {
                es: 'Administra los usuarios del sistema de seguros ASISA.',
                en: 'Manage users of the ASISA insurance system.',
                zh: '管理ASISA保险系统的用户。',
                de: 'Verwalten Sie die Benutzer des ASISA-Versicherungssystems.',
                fr: 'Gérez les utilisateurs du système d\'assurance ASISA.',
                ar: 'إدارة مستخدمي نظام التأمين ASISA.'
            },
            requiresAuth: true,
            requiresAdmin: true
        }
    },

    // ============================================
    // ÁREA PRIVADA
    // ============================================
    {
        path: '/:lang/AreaPrivada',
        component: AreaPrivada,
        props: true,
        name: 'AreaPrivada',
        meta: {
            title: {
                es: 'Gestión de Pólizas | ASISA',
                en: 'Policy Management | ASISA',
                zh: '保单管理 | ASISA',
                de: 'Policenverwaltung | ASISA',
                fr: 'Gestion des polices | ASISA',
                ar: 'إدارة البوالص | ASISA'
            },
            description: {
                es: 'Gestiona tus pólizas de seguro, descarga certificados y consulta tu historial.',
                en: 'Manage your insurance policies, download certificates and check your history.',
                zh: '管理您的保险单，下载证书并查看您的历史记录。',
                de: 'Verwalten Sie Ihre Versicherungspolicen, laden Sie Zertifikate herunter und prüfen Sie Ihren Verlauf.',
                fr: 'Gérez vos polices d\'assurance, téléchargez des certificats et consultez votre historique.',
                ar: 'إدارة بوالص التأمين الخاصة بك، وتنزيل الشهادات والتحقق من سجلك.'
            },
            requiresAuth: true
        }
    },

    // ============================================
    // VENCIMIENTOS
    // ============================================
    {
        path: '/:lang/vencimientos',
        component: Vencimientos,
        name: 'vencimientos',
        props: true,
        meta: {
            title: {
                es: 'Calendario de Vencimientos | ASISA',
                en: 'Expiry Calendar | ASISA',
                zh: '到期日历 | ASISA',
                de: 'Verfallskalender | ASISA',
                fr: 'Calendrier des échéances | ASISA',
                ar: 'تقويم انتهاء الصلاحية | ASISA'
            },
            description: {
                es: 'Consulta las fechas de vencimiento de tus pólizas y recibe recordatorios.',
                en: 'Check your policy expiry dates and receive reminders.',
                zh: '查看您的保单到期日期并接收提醒。',
                de: 'Prüfen Sie Ihre Policenablaufdaten und erhalten Sie Erinnerungen.',
                fr: 'Consultez les dates d\'expiration de vos polices et recevez des rappels.',
                ar: 'تحقق من تواريخ انتهاء صلاحية بوالصك وتلقي التذكيرات.'
            },
            requiresAuth: true
        }
    },

    // ============================================
    // SOPORTE
    // ============================================
    {
        path: '/:lang/soporte',
        component: Soporte,
        name: 'soporte',
        props: true,
        meta: {
            title: {
                es: 'Centro de Soporte | ASISA',
                en: 'Support Center | ASISA',
                zh: '支持中心 | ASISA',
                de: 'Support-Center | ASISA',
                fr: 'Centre de support | ASISA',
                ar: 'مركز الدعم | ASISA'
            },
            description: {
                es: 'Contacta con nuestro equipo de soporte para resolver tus dudas sobre tu seguro.',
                en: 'Contact our support team to resolve your questions about your insurance.',
                zh: '联系我们的支持团队，解决您关于保险的疑问。',
                de: 'Kontaktieren Sie unser Support-Team, um Ihre Fragen zu Ihrer Versicherung zu klären.',
                fr: 'Contactez notre équipe de support pour résoudre vos questions sur votre assurance.',
                ar: 'اتصل بفريق الدعم لدينا لحل أسئلتك حول تأمينك.'
            },
            requiresAuth: true
        }
    },

    // ============================================
    // BLOG
    // ============================================
    {
        path: '/:lang/blog',
        component: () => import('@/views/Blog.vue'),
        name: 'blog',
        props: true,
        meta: {
            title: {
                es: 'Guía de Trámites para Mudarse a España | Blog ASISA Health Visa',
                en: 'Moving to Spain Guide | ASISA Health Visa Blog',
                zh: '移居西班牙指南 | ASISA Health Visa 博客',
                de: 'Umzugsleitfaden für Spanien | ASISA Health Visa Blog',
                fr: 'Guide pour déménager en Espagne | Blog ASISA Health Visa',
                ar: 'دليل الانتقال إلى إسبانيا | مدونة ASISA Health Visa'
            },
            description: {
                es: 'Todo lo que necesitas saber para obtener NIE, empadronamiento, residencia fiscal y otros trámites al mudarte a España.',
                en: 'Everything you need to know to get NIE, registration, tax residency and other procedures when moving to Spain.',
                zh: '移居西班牙时，您需要了解的有关获得NIE、登记、税务居民身份和其他程序的所有信息。',
                de: 'Alles, was Sie über die Erlangung von NIE, Anmeldung, Steuerwohnsitz und andere Verfahren bei einem Umzug nach Spanien wissen müssen.',
                fr: 'Tout ce que vous devez savoir pour obtenir le NIE, l\'inscription, la résidence fiscale et autres procédures lors de votre déménagement en Espagne.',
                ar: 'كل ما تحتاج لمعرفته للحصول على NIE والتسجيل والإقامة الضريبية والإجراءات الأخرى عند الانتقال إلى إسبانيا.'
            },
            keywords: {
                es: 'mudarse a España, NIE, empadronamiento, residencia fiscal',
                en: 'move to Spain, NIE, registration, tax residency',
                zh: '移居西班牙，NIE，登记，税务居民',
                de: 'Umzug nach Spanien, NIE, Anmeldung, Steuerwohnsitz',
                fr: 'déménager en Espagne, NIE, inscription, résidence fiscale',
                ar: 'الانتقال إلى إسبانيا، NIE، التسجيل، الإقامة الضريبية'
            }
        }
    },

    // ============================================
    // NOT FOUND
    // ============================================
    {
        path: '/:lang/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound,
        props: true,
        meta: {
            title: {
                es: 'Página no encontrada | ASISA',
                en: 'Page not found | ASISA',
                zh: '页面未找到 | ASISA',
                de: 'Seite nicht gefunden | ASISA',
                fr: 'Page non trouvée | ASISA',
                ar: 'الصفحة غير موجودة | ASISA'
            }
        }
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/es'
    },

    // ============================================
    // CALCULADORA
    // ============================================
    {
        path: '/:lang/calculadora',
        component: () => import('@/views/Calculadora.vue'),
        name: 'calculadora',
        props: true,
        meta: {
            title: {
                es: 'Calculadora de Tarifas ASISA Health Residents | Seguros para Visa y NIE',
                en: 'ASISA Health Residents Rate Calculator | Insurance for Visa and NIE',
                zh: 'ASISA Health Residents 费率计算器 | 签证和NIE保险',
                de: 'ASISA Health Residents Tarifrechner | Versicherung für Visum und NIE',
                fr: 'Calculateur de tarifs ASISA Health Residents | Assurance pour Visa et NIE',
                ar: 'حاسبة أسعار ASISA Health Residents | تأمين للتأشيرة و NIE'
            },
            description: {
                es: 'Calcula online el precio de tu seguro médico ASISA Health Residents para obtener tu visado o residencia en España.',
                en: 'Calculate the price of your ASISA Health Residents insurance online to get your visa or residency in Spain.',
                zh: '在线计算您的ASISA Health Residents保险价格，以获得您在西班牙的签证或居留权。',
                de: 'Berechnen Sie den Preis Ihrer ASISA Health Residents Versicherung online, um Ihr Visum oder Ihren Aufenthalt in Spanien zu erhalten.',
                fr: 'Calculez en ligne le prix de votre assurance ASISA Health Residents pour obtenir votre visa ou résidence en Espagne.',
                ar: 'احسب سعر تأمين ASISA Health Residents الخاص بك عبر الإنترنت للحصول على تأشيرتك أو إقامتك في إسبانيا.'
            },
            keywords: {
                es: 'calculadora seguro salud, precio seguro médico, ASISA Health Residents',
                en: 'health insurance calculator, medical insurance price, ASISA Health Residents',
                zh: '健康保险计算器，医疗保险价格，ASISA Health Residents',
                de: 'Krankenversicherungsrechner, Krankenversicherungspreis, ASISA Health Residents',
                fr: 'calculatrice assurance santé, prix assurance médicale, ASISA Health Residents',
                ar: 'حاسبة التأمين الصحي، سعر التأمين الطبي، ASISA Health Residents'
            }
        }
    },

    // ============================================
    // AVISO LEGAL
    // ============================================
    {
        path: '/:lang/aviso-legal',
        component: () => import('@/views/AvisoLegal.vue'),
        name: 'aviso-legal',
        props: true,
        meta: {
            title: {
                es: 'Aviso Legal | Unit Seguros',
                en: 'Legal Notice | Unit Seguros',
                zh: '法律声明 | Unit Seguros',
                de: 'Impressum | Unit Seguros',
                fr: 'Mentions légales | Unit Seguros',
                ar: 'إشعار قانوني | Unit Seguros'
            },
            description: {
                es: 'Aviso legal y condiciones generales de uso de Unit Seguros',
                en: 'Legal notice and general terms of use of Unit Seguros',
                zh: 'Unit Seguros 的法律声明和一般使用条件',
                de: 'Impressum und allgemeine Nutzungsbedingungen von Unit Seguros',
                fr: 'Mentions légales et conditions générales d\'utilisation de Unit Seguros',
                ar: 'إشعار قانوني والشروط العامة لاستخدام Unit Seguros'
            }
        }
    },

    // ============================================
    // POLÍTICA DE PRIVACIDAD
    // ============================================
    {
        path: '/:lang/politica-privacidad',
        component: () => import('@/views/Privacidad.vue'),
        name: 'politica-privacidad',
        props: true,
        meta: {
            title: {
                es: 'Política de Privacidad | Unit Seguros',
                en: 'Privacy Policy | Unit Seguros',
                zh: '隐私政策 | Unit Seguros',
                de: 'Datenschutzerklärung | Unit Seguros',
                fr: 'Politique de confidentialité | Unit Seguros',
                ar: 'سياسة الخصوصية | Unit Seguros'
            },
            description: {
                es: 'Política de privacidad y protección de datos de Unit Seguros',
                en: 'Privacy policy and data protection of Unit Seguros',
                zh: 'Unit Seguros 的隐私政策和数据保护',
                de: 'Datenschutzerklärung und Datenschutz von Unit Seguros',
                fr: 'Politique de confidentialité et protection des données de Unit Seguros',
                ar: 'سياسة الخصوصية وحماية البيانات لـ Unit Seguros'
            }
        }
    },
    {
        path: '/:lang/ficha-producto',
        component: FichaProducto,
        name: 'ficha-producto',
        props: true,
        meta: {
            title: {
                es: 'Ficha de Producto ASISA Health Residents | ASISA',
                en: 'ASISA Health Residents Product Sheet | ASISA',
                zh: 'Unit Seguros 的隐私政策和数据保护',
                de: 'Datenschutzerklärung und Datenschutz von Unit Seguros',
                fr: 'Politique de confidentialité et protection des données de Unit Seguros',
                ar: 'سياسة الخصوصية وحماية البيانات لـ Unit Seguros'
            }
        }
    },
    // ============================================
    // AVISO LEGAL (el nuevo para aceptación)
    // ============================================
    {
        path: '/:lang/aviso-legalck',
        component: AvisoLegalCheck,
        name: 'aviso-legalck',
        props: true,
        meta: {
            title: {
                es: 'Aviso Legal | Unit Seguros',
                en: 'Legal Notice | Unit Seguros',
                zh: '法律声明 | Unit Seguros',
                de: 'Impressum | Unit Seguros',
                fr: 'Mentions légales | Unit Seguros',
                ar: 'إشعار قانوني | Unit Seguros'
            },
            description: {
                es: 'Aviso legal y condiciones generales de uso de Unit Seguros. Acepta para continuar con la contratación.',
                en: 'Legal notice and general terms of use of Unit Seguros. Accept to continue with the contracting process.',
                zh: 'Unit Seguros 的法律声明和一般使用条件。接受以继续签约流程。',
                de: 'Impressum und allgemeine Nutzungsbedingungen von Unit Seguros. Akzeptieren Sie, um mit dem Vertragsabschluss fortzufahren.',
                fr: 'Mentions légales et conditions générales d\'utilisation de Unit Seguros. Acceptez pour continuer le processus de souscription.',
                ar: 'إشعار قانوني والشروط العامة لاستخدام Unit Seguros. وافق للمتابعة مع عملية الاشتراك.'
            }
        }
    },
    {
        path: '/:lang/politica-cookies',
        name: 'politica-cookies',
        props: true,
        component: PoliticaCookies,
        meta: { 
            title: {
                es: 'ASISA Health Visa | Seguro de Salud para Expatriados en España',
                en: 'ASISA Health Visa | Health Insurance for Expats in Spain',
                zh: 'ASISA Health Visa | 西班牙外籍人士健康保险',
                de: 'ASISA Health Visa | Krankenversicherung für Expats in Spanien',
                fr: 'ASISA Health Visa | Assurance santé pour expatriés en Espagne',
                ar: 'ASISA Health Visa | تأمين صحي للمغتربين في إسبانيا'
            }
         }
    }
]

const router = createRouter({
    routes,
    history: createWebHistory()
})

router.beforeEach((to, from, next) => {
    // 1. Obtener idioma
    const locale = to.params.lang || 'es'
    
    // 2. ✅ Cambiar idioma de i18n (usando i18n importado)
    if (i18n && i18n.global) {
        i18n.global.locale = locale
        console.log('🔄 Idioma cambiado a:', locale) // Para depurar
    }
    
    // 3. Aplicar meta SEO
    if (to.meta.title) {
        const title = typeof to.meta.title === 'object' 
            ? (to.meta.title[locale] || to.meta.title.es) 
            : to.meta.title
        document.title = title
    }
    
    if (to.meta.description) {
        const description = typeof to.meta.description === 'object' 
            ? (to.meta.description[locale] || to.meta.description.es) 
            : to.meta.description
        const tag = document.querySelector('meta[name="description"]')
        if (tag) tag.content = description
    }
    
    if (to.meta.keywords) {
        const keywords = typeof to.meta.keywords === 'object' 
            ? (to.meta.keywords[locale] || to.meta.keywords.es) 
            : to.meta.keywords
        const tag = document.querySelector('meta[name="keywords"]')
        if (tag) tag.content = keywords
    }
    
    // 4. Autenticación
    const requiresAuth = to.meta.requiresAuth
    const requiresAdmin = to.meta.requiresAdmin
    
    if (requiresAuth) {
        const session = localStorage.getItem('expat_visa_session')
        const user = localStorage.getItem('user')
        const rol = localStorage.getItem('user_rol')

        console.log("aaa " + rol)
        
        if (!session || !user) {
            next({ name: 'login', params: { lang: locale } })
            return
        }
        
        if (requiresAdmin && rol !== 'admin') {
            next({ name: 'AreaPrivada', params: { lang: locale } })
            return
        }
    }
    
    // 5. Continuar
    next()
})

export default router;